import { Component, Output, EventEmitter, Injector, Input } from '@angular/core';
import { GetEmpty } from 'src/app/classes/Empties';
import { Utils } from 'src/app/classes/Utils';
import { Bank_Account, Currency, Store, Withdrawal } from 'src/app/models/RestModels';
import { BaseComponent } from 'src/app/pages/base/base.component';
import { PrinterService, shouldPrintUsbTicket } from 'src/app/services/printer.service';

@Component({
	selector: 'app-add-withdrawal',
	templateUrl: './add-withdrawal.component.html',
	styleUrls: ['./add-withdrawal.component.css']
})
export class AddWithdrawalComponent extends BaseComponent
{
	total: number | null = null;
	note: string = '';
	imprimir_recibo: boolean = true;
	bank_account_list: Bank_Account[] = [];
	dest_bank_account_id: number | null = null;
	currency_list: Currency[] = [];
	currency_id: string = 'MXN';
	@Input() store_id: number | null = null;
	@Output() withdrawalAdded = new EventEmitter<void>();

	private printerService: PrinterService;

	constructor(public injector: Injector) {
		super(injector);
		this.printerService = injector.get(PrinterService);
	}

	ngOnInit(): void
	{
		this.total = null;
		this.note = '';
		this.dest_bank_account_id = null;

		this.subs.sink = this.rest.bank_account.search({})
			.subscribe((response) =>
			{
				this.bank_account_list = response.data;
			}, (error) => this.showError(error));

		this.subs.sink = this.rest.currency.search({ limit: 999999 })
			.subscribe((response) =>
			{
				this.currency_list = response.data;
			}, (error) => this.showError(error));
	}

	save(evt: Event)
	{
		evt.preventDefault();
		this.is_loading = true;

		let now = new Date();
		let pad = (n: number) => (n < 10 ? '0' : '') + n;
		let mysql_datetime = now.getFullYear() + '-' +
			pad(now.getMonth() + 1) + '-' +
			pad(now.getDate()) + ' ' +
			pad(now.getHours()) + ':' +
			pad(now.getMinutes()) + ':' +
			pad(now.getSeconds());

		let payload: any = {
			amount: this.total,
			currency_id: this.currency_id,
			currency: this.currency_id,
			device_time: mysql_datetime,
			store_id: this.store_id,
			note: this.note,
		};

		if (this.dest_bank_account_id)
		{
			payload.dest_bank_account_id = this.dest_bank_account_id;
		}

		this.subs.sink = this.rest.withdrawal_info
			.create(payload)
			.subscribe((response: any) =>
			{
				let withdrawal = response?.withdrawal || response;
				if (this.imprimir_recibo && withdrawal?.id)
				{
					let prefs = this.printerService.resolvePreferences(this.rest.current_user);
					if (shouldPrintUsbTicket(prefs, withdrawal.id))
					{
						this.printWithdrawalUsb(evt, withdrawal)
							.catch((error) =>
							{
								console.error('USB withdrawal print failed, falling back to browser print:', error);
								this.showError('Error al imprimir por USB, abriendo impresión normal: ' + (error?.message || 'Error desconocido'));
								Utils.openPrintTab('/#/print-withdrawal/' + withdrawal.id + '/print=1');
							});
					}
					else
					{
						Utils.openPrintTab('/#/print-withdrawal/' + withdrawal.id + '/print=1');
					}
				}
				this.showSuccess('El retiro se guardó exitosamente');
				this.resetForm();
				this.withdrawalAdded.emit();
				this.is_loading = false;
			}, (error) => this.showError(error));
	}

	async printWithdrawalUsb(evt: Event, withdrawal: Withdrawal): Promise<void>
	{
		if (this.printerService.available_printers.length === 0)
		{
			const storeId = withdrawal?.store_id || this.store_id || this.rest.current_user?.store_id;
			if (storeId)
			{
				const response = await this.rest.printer.search({
					limit: 9999,
					eq: { store_id: storeId },
					sort_order: ['name_ASC']
				}).toPromise();
				this.printerService.available_printers = response.data;
			}
		}

		if (!this.printerService.isUsbPrintingEnabled())
		{
			throw new Error('No hay impresora USB configurada. Configure la impresora en ajustes.');
		}

		const prefs = this.printerService.resolvePreferences(this.rest.current_user);
		const printer = this.printerService.available_printers.find(p => p.id === prefs.pos_printer_id);

		if (!printer)
		{
			throw new Error('La impresora configurada no existe en esta sucursal. Revise la configuración.');
		}

		const storeId = withdrawal?.store_id || this.store_id || this.rest.current_user?.store_id;
		let store: Store = GetEmpty.store();
		if (storeId)
		{
			store = await this.rest.store.get(storeId).toPromise();
		}

		const result = await this.printerService.printWithdrawal({
			withdrawal,
			store,
			user_name: this.rest.current_user?.name || ''
		}, 1, evt);

		if (!result.success)
		{
			throw new Error(result.message || 'Error desconocido al imprimir');
		}

		this.showSuccess('Retiro impreso correctamente');
	}

	resetForm()
	{
		this.total = null;
		this.note = '';
		this.dest_bank_account_id = null;
		this.currency_id = 'MXN';
	}

	cancel()
	{
		this.withdrawalAdded.emit();
	}

	imprimirChanged(evt: Event)
	{
		let input = evt.target as HTMLInputElement;
		this.imprimir_recibo = input.checked;
	}
}
